<template>
    <div class="train-manage-page">
		<div id="approvalForm" ref="approvalForm"  :class="viewStatus?'view-detail':''">
			<i class="el-icon-circle-close" v-if="viewStatus" @click="viewStatus=false;pdfData={}"></i>
			<div class="pdf-row-1 pdf-row">
				<div class="row-1-column-1 row-column">
					智慧工地产品培训确认单
				</div>
				<div class="row-1-column-2 row-column">编    号</div>
				<div class="row-1-column-3 row-column">{{ pdfData.docNum }}</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">项目名称</div>
				<div class="row-2-column-2 row-column">{{ pdfData.projectName }}</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">项目地址</div>
				<div class="row-2-column-2 row-column">{{ pdfData.address }}</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">所属单位</div>
				<div class="row-2-column-2 row-column">{{ pdfData.companyName }}</div>
			</div>
			<div class="pdf-row-3 pdf-row">
				<div class="row-3-column-1 row-column">联系人</div>
				<div class="row-3-column-2 row-column">{{ pdfData.projectLeader }}</div>
				<div class="row-3-column-1 row-column">联系方式</div>
				<div class="row-3-column-2 row-column">{{ pdfData.projectLeaderPhone }}</div>
			</div>
			<div class="pdf-row-3 pdf-row">
				<div class="row-3-column-1 row-column">销售经理</div>
				<div class="row-3-column-2 row-column"><span v-if="pdfData.salePersons">{{ pdfData.salePersons.map(item => item.personName).join('、') }}</span></div>
				<div class="row-3-column-1 row-column">培训方式</div>
				<div class="row-3-column-2 row-column">{{ pdfData.trainTypeName }}</div>
			</div>
			<div class="pdf-row-3 pdf-row">
				<div class="row-3-column-1 row-column">培训时长</div>
				<div class="row-3-column-2 row-column">{{ pdfData.trainHour }} 小时</div>
				<div class="row-3-column-1 row-column">参加培训人员</div>
				<div class="row-3-column-2 row-column">{{ pdfData.trainPersonCount }} 人</div>
			</div>
			<div class="pdf-row-4 pdf-row">
				<div class="suggestion">改进意见：</div>
				<div class="suggestion-content">{{ pdfData.improveSuggestion }}</div>
			</div>
			<div class="pdf-row-5 pdf-row">
				<div class="row-5-column-1 row-column">签字栏</div>
				<div class="row-5-column-2 row-column">
					<div class="label">项目负责人</div>
					<div class="content">
						<el-image
							style="width: 100px; height: 50px"
							:src="pdfData.leaderSignaturePic"
							fit="fill"
							@load="pictureLoaded"
							@error="pictureLoaded"
						></el-image>
					</div>
				</div>
				<div class="row-5-column-2 row-column">
					<div class="label">培训人员</div>
					<div class="content" v-if="pdfData.trainPersons">{{ pdfData.trainPersons.map(item => item.personName).join('、') }}</div>
				</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">培训日期</div>
				<div class="row-2-column-2 row-column">{{ pdfData.trainDateStr }}</div>
			</div>
		</div>
        <header>
			培训日期：
			<el-date-picker 
				class="picker"
				type="daterange" 
				v-model="search.trainDate" 
				placeholder="选择日期"
				value-format="yyyy-MM-dd"
				clearable
			></el-date-picker>
			项目名称：
			<el-select style="width: 150px" v-model="search.projectName" placeholder="请选择" filterable clearable>
				<el-option
					v-for="pro in projectList"
					:key="pro.item1"
					:label="pro.item2"
					:value="pro.item2"
				>
				</el-option>
			</el-select>
      		销售经理：
			<el-select style="width: 150px" v-model="search.salesManager" placeholder="请选择" filterable clearable>
				<el-option
					v-for="pro in salesManagerList"
					:key="pro.id"
					:label="pro.name"
					:value="pro.id"
				>
				</el-option>
			</el-select>
			培训人员：
			<el-select style="width: 150px" v-model="search.trainPersonId" placeholder="请选择" filterable clearable>
				<el-option
					v-for="pro in trainerList"
					:key="pro.id"
					:label="pro.name"
					:value="pro.id"
				>
				</el-option>
			</el-select>
			培训方式：
			<el-select style="width: 150px" v-model="search.trainType" placeholder="请选择" filterable clearable>
				<el-option
					v-for="pro in trainTypeOptions"
					:key="pro.dicId"
					:label="pro.dicName"
					:value="pro.dicId"
				>
				</el-option>
			</el-select>
			<el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="getTrainPageList">查询</el-button>
			<el-button type="primary" @click="toSettings">设置</el-button>
			<el-button type="primary" @click="generatePDFs" :disabled="!exportIdList.length" :loading="exportLoading">批量导出</el-button>
		</header>
		<el-table :data="tableData" style="width: 100%;margin-top: 20px;" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column type="index" label="序号" width="80" ></el-table-column>
			<el-table-column prop="projectName" label="项目名称"></el-table-column>
			<el-table-column label="销售经理">
				<template slot-scope="scope">{{ scope.row.salePersons.join('、') }}</template>
			</el-table-column>
			<el-table-column label="培训人员">
				<template slot-scope="scope">{{ scope.row.trainPersons.join('、') }}</template>
			</el-table-column>
			<el-table-column prop="trainDateStr" label="培训日期"></el-table-column>
			<el-table-column label="培训方式">
				<template slot-scope="scope">{{ scope.row.trainTypeName }}</template>
			</el-table-column>
			<el-table-column label="培训确认单">
				<template slot-scope="scope">
					<el-link type="primary" style="color: white" underline @click="getItemDetail(scope.row.id)">查看</el-link>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="120">
				<template slot-scope="scope">
					<el-button type="text" @click="generateApprovalPDF(scope.row.id)">导出</el-button>
					<el-button type="text" @click="deleteTrainById(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="tc" style="margin-top:20px">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pageIndex"
				:page-sizes="[ 10, 20, 50 ]"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>
		<el-dialog
			title="设置"
			:visible.sync="setDialogVisible"
			width="40%"
			center
			:close-on-click-modal="false"
			:append-to-body="false"
			custom-class="dialog-class"
		>
			<div class="set-item" style="display: flex;margin-bottom: 20px;">
				<div class="item-label" style="width: 150px;height: 40px;line-height: 40px;text-align: right;">销售经理人员维护：</div>
				<div class="item-content" style="display: flex;align-items: center;flex-wrap: wrap;justify-content: flex-start;flex: 1;">
					<div v-for="(item, index) in salesManagerSetList" style="display: flex;flex-direction: column;">
						<el-input
							placeholder="请输入姓名" v-model="item['name']" 
							clearable style="width: 150px;padding: 2px;"
							@change="changeInput(index, 'salesManager')"
							@blur="changeInput(index, 'salesManager')"
							v-if="!item.isDelete"
						></el-input>
						<el-input
							placeholder="请输入手机号" v-model="item['telephone']" 
							clearable style="width: 150px;padding: 2px;"
							@change="changeInput(index, 'salesManager')"
							@blur="changeInput(index, 'salesManager')"
							v-if="!item.isDelete"
						></el-input>
						<p style="height: 16px;color: #f56c6c;font-size: 12px;" v-if="item['telephone'] && !item.isDelete && !isPhoneNumber(item['telephone'])">请输入正确手机号</p>
						<p style="height: 16px;" v-else-if="isPhoneNumber(item['telephone'])||item['telephone']===''"></p>
					</div>
					
					<i class="el-icon-circle-plus-outline" 
						@click="salesManagerSetList.push({name: '',telephone: '',id: 0, isDelete: false})" 
						style="font-size: 25px;
						margin-left: 10px;"
					></i>
				</div>
			</div>
			<div class="set-item" style="display: flex;margin-bottom: 20px;">
				<div class="item-label" style="width: 150px;height: 40px;line-height: 40px;text-align: right;">培训人员维护：</div>
				<div class="item-content" style="display: flex;align-items: center;flex-wrap: wrap;justify-content: flex-start;flex: 1;">
					<div v-for="(item, index) in trainerSetList" style="display: flex;flex-direction: column;">
						<el-input
							placeholder="请输入姓名" v-model="item['name']" 
							clearable style="width: 150px;padding: 2px;"
							@change="changeInput(index, 'trainer')"
							@blur="changeInput(index, 'trainer')"
							v-if="!item.isDelete"
						></el-input>
						<el-input
							placeholder="请输入手机号" v-model="item['telephone']" 
							clearable style="width: 150px;padding: 2px;"
							@change="changeInput(index, 'trainer')"
							@blur="changeInput(index, 'trainer')"
							v-if="!item.isDelete"
						></el-input>
						<p style="height: 16px;color: #f56c6c;font-size: 12px;" v-if="item['telephone'] && !item.isDelete && !isPhoneNumber(item['telephone'])">请输入正确手机号</p>
						<p style="height: 16px;" v-else-if="isPhoneNumber(item['telephone'])||item['telephone']===''"></p>
					</div>
					<i class="el-icon-circle-plus-outline" 
						@click="trainerSetList.push({name: '',telephone: '',id: 0, isDelete: false})" 
						style="font-size: 25px;
						margin-left: 10px;"
					></i>
				</div>
			</div>
			<div class="set-item" style="display: flex;">
				<div class="item-label" style="width: 150px;height: 40px;line-height: 40px;text-align: right;">培训方式：</div>
				<div class="item-content" style="display: flex;align-items: center;flex-wrap: wrap;justify-content: flex-start;flex: 1;">
					<el-input 
						v-for="(item, index) in trainTypeSetOptions" 
						placeholder="请输入" v-model="trainTypeSetOptions[index]['dicName']" 
						clearable style="width: 150px;padding: 2px;"
						@change="changeInput(index,'trainWay')"
						@blur="changeInput(index,'trainWay')"
						v-if="!item.isDelete"
					></el-input>
					<i class="el-icon-circle-plus-outline" 
						@click="trainTypeSetOptions.push({dicId: 0,dicName: '',isDelete: false})" 
						style="font-size: 25px;
						margin-left: 10px;"
					></i>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
                <el-button @click="cancalSet">取 消</el-button>
                <el-button type="primary" @click="setConfirm">确 定</el-button>
            </span>
		</el-dialog>
		<div
			v-for="(item, index) in implementExportList"
			:key="index"
			id="approvalBatchForm" 
			ref="approvalForm"
			:ref="(el) => (contentRefs[index] = el)"
		>
			<div class="pdf-row-1 pdf-row">
				<div class="row-1-column-1 row-column">
					智慧工地产品培训确认单
				</div>
				<div class="row-1-column-2 row-column">编    号</div>
				<div class="row-1-column-3 row-column">{{ item.docNum }}</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">项目名称</div>
				<div class="row-2-column-2 row-column">{{ item.projectName }}</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">项目地址</div>
				<div class="row-2-column-2 row-column">{{ item.address }}</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">所属单位</div>
				<div class="row-2-column-2 row-column">{{ item.companyName }}</div>
			</div>
			<div class="pdf-row-3 pdf-row">
				<div class="row-3-column-1 row-column">联系人</div>
				<div class="row-3-column-2 row-column">{{ item.projectLeader }}</div>
				<div class="row-3-column-1 row-column">联系方式</div>
				<div class="row-3-column-2 row-column">{{ item.projectLeaderPhone }}</div>
			</div>
			<div class="pdf-row-3 pdf-row">
				<div class="row-3-column-1 row-column">销售经理</div>
				<div class="row-3-column-2 row-column"><span v-if="item.salePersons">{{ item.salePersons.map(im => im.personName).join('、') }}</span></div>
				<div class="row-3-column-1 row-column">培训方式</div>
				<div class="row-3-column-2 row-column">{{ item.trainTypeName }}</div>
			</div>
			<div class="pdf-row-3 pdf-row">
				<div class="row-3-column-1 row-column">培训时长</div>
				<div class="row-3-column-2 row-column">{{ item.trainHour }} 小时</div>
				<div class="row-3-column-1 row-column">参加培训人员</div>
				<div class="row-3-column-2 row-column">{{ item.trainPersonCount }} 人</div>
			</div>
			<div class="pdf-row-4 pdf-row">
				<div class="suggestion">改进意见：</div>
				<div class="suggestion-content">{{ item.improveSuggestion }}</div>
			</div>
			<div class="pdf-row-5 pdf-row">
				<div class="row-5-column-1 row-column">签字栏</div>
				<div class="row-5-column-2 row-column">
					<div class="label">项目负责人</div>
					<div class="content">
						<el-image
							style="width: 100px; height: 50px"
							:src="item.leaderSignaturePic"
							fit="fill"
						></el-image>
					</div>
				</div>
				<div class="row-5-column-2 row-column">
					<div class="label">培训人员</div>
					<div class="content" v-if="item.trainPersons">{{ item.trainPersons.map(im => im.personName).join('、') }}</div>
				</div>
			</div>
			<div class="pdf-row-2 pdf-row">
				<div class="row-2-column-1 row-column">培训日期</div>
				<div class="row-2-column-2 row-column">{{ item.trainDateStr }}</div>
			</div>
		</div>
    </div>
</template>

<script>
import { getUserListByType, savePersonList, saveUnitDictionary, getProjectList } from '@/api/acceptance'; 
import { getProcuctList, deleteTrain, exportTrain, getDataDictionary } from "@/api/productTrain.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import saveAs from "file-saver";
import JSZip from "jszip";
export default {
    data() {
        return {
            search: {
				trainDate: "",
				projectName: "",
				salesManager: "",
				trainPersonId: '',
            },
			pageIndex: 1,
			pagesize: 10,
			total: 100,
			setDialogVisible: false,
			tableData: [],
			salesManagerList: [],
			trainerList: [],
			trainTypeOptions: [],
            projectList: [],
			pdfData: {},
			implementExportList: [8, 9, 10],
			trainTypeSetOptions: [],
			salesManagerSetList: [],
			trainerSetList: [],
			viewStatus: false,
			imgUrlprefix: `http://${process.env.npm_config_ip}:8304/center`,
			exportIdList: [],
			contentRefs: [],
			exportLoading: false
        }
    },
	mounted() {
		this.initGetProjectList();
		this.getSalesManagerList();
		this.getTrainerList();
        this.getTrainWayDict();
        this.getTrainPageList();
	},
	methods: {
		handleSelectionChange(rows) {
			this.exportIdList = [];
			rows.forEach((item, index) => {
				this.exportIdList.push(item.id);
			})
		},
		getItemDetail(val) {
			exportTrain({trainIdList: [val]}).then(res => {
				let target = res.data.data[0];
				if(!target.leaderSignaturePic.startsWith('http')) {
					this.$set(target,'leaderSignaturePic',`${this.imgUrlprefix}${target.leaderSignaturePic}`)
				}
				this.pdfData = target;
				this.viewStatus = true;
			}).catch(() => {});
		},
		pictureLoaded() {
			if(!Object.keys(this.pdfData).length || this.viewStatus) return;
			const domElement = this.$refs.approvalForm;
			html2canvas(domElement, {
				dpi: 300, // 提高DPI以获得更好的打印质量
				width: 860,
				useCORS: true
			}).then((canvas) => {
				const imgData = canvas.toDataURL("image/png");
				const pdf = new jsPDF("p", "mm", "a4"); // 页面大小为A4
				const imgWidth = pdf.internal.pageSize.getWidth();

				// 计算图片的原始比例
				const imageRatio = canvas.width / canvas.height;

				// 初始化PDF页面高度
				let pageHeight = pdf.internal.pageSize.getHeight();

				// 添加图片，保留比例
				const imgHeight = imgWidth / imageRatio;
				pdf.addImage(imgData, "PNG", 10, 10, imgWidth - 20, imgHeight);

				// 检查图片是否超出当前页面高度
				if ((pdf.internal.pageSize.y + imgHeight) > pageHeight) {
					// 创建新页并调整页面高度
					pdf.addPage();
					pageHeight = pdf.internal.pageSize.getHeight();
				}
				pdf.save(`培训确认单${this.pdfData.docNum}.pdf`);
				setTimeout(() => {
					this.pdfData = {};
				},0)
			});
		},
		isPhoneNumber(phoneNumber) {
			const phoneRegex = /^1[3-9]\d{9}$/; // 匹配13到19开头的11位数字
			return phoneRegex.test(phoneNumber);
		},
		async generatePDFs() {
			this.exportLoading = true;
			exportTrain({trainIdList: this.exportIdList}).then(res => {
				this.implementExportList = res.data.data;
				this.implementExportList = this.implementExportList.map(item => ({
					...item,
					leaderSignaturePic: !item.leaderSignaturePic.startsWith('http') ? `${this.imgUrlprefix}${item.leaderSignaturePic}` : item.leaderSignaturePic
				}))
				this.implementExportList.forEach(() => (this.contentRefs.push(null)));
				setTimeout(() => {
					this.exportAll();
				}, 0.2 * 1000)
			}).catch(() => {this.exportLoading = false;});

		},
		async exportAll() {
			const zip = new JSZip();

			for (let i = 0; i < this.implementExportList.length; i++) {
			const element = this.contentRefs[i];
			if (!element) continue; // 如果元素不存在，跳过

			const canvas = await html2canvas(element, {
				dpi: 300,
				allowTaint: true,
				useCORS: true,
			});

			const imgData = canvas.toDataURL("image/png");
			const doc = new jsPDF("p", "mm", "a4");
			const imgWidth = doc.internal.pageSize.getWidth();
			const imgHeight = (canvas.height * imgWidth) / canvas.width;
			doc.addImage(imgData, "PNG", 10, 10, imgWidth - 20, imgHeight);

			const pdfBlob = await new Response(doc.output("blob")).blob();
			zip.file(`培训确认单${this.implementExportList[i].docNum}.pdf`, pdfBlob);
			}

			// 生成ZIP文件并下载
			const content = await zip.generateAsync({ type: "blob" });
			saveAs(content, "all_contents.zip");
			setTimeout(() => {
				this.implementExportList = [];
				this.exportLoading = false;
			},0)
		},
		generateApprovalPDF(val) {
			exportTrain({trainIdList: [val]}).then(res => {
				this.pdfData = res.data.data[0];
				if(!this.pdfData.leaderSignaturePic.startsWith('http')) {
					this.$set(this.pdfData,'leaderSignaturePic',`${this.imgUrlprefix}${this.pdfData.leaderSignaturePic}`)
				}
			}).catch(() => {});
		},
        initGetProjectList() {
            getProjectList().then(res => {
                this.projectList = res.data.data;
            }).catch(() => {});
        },
		deleteTrainById(val) {
			this.$confirm(`是否删除`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        let data = {
                            acceptid: val
                        }
                        deleteTrain(data).then(res => {
                            if(res.data.statusCode === 200) {
                                this.$message({type:"success",message:`删除成功`});
                                instance.confirmButtonLoading = false;
                                done();
                                this.getTrainPageList();
                            }else {
                                instance.confirmButtonLoading = false;
                                done();
                            }
                        }).catch(err => {
                            this.$message({type:"error",message:err.errMsg});
                            instance.confirmButtonLoading = false;
                            done();
                        })
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(() => {}).catch(() => {})
		},
		cancalSet() {
			this.setDialogVisible = false;
		},
		setConfirm() {
			let condition01 = this.salesManagerSetList.filter(item => item['name']===""||item['telephone']==="");
			let condition02 = this.trainerSetList.filter(item => item['name']===""||item['telephone']==="");
			let condition03 = this.trainTypeSetOptions.filter(item => item.dicName === "");
			if(condition01.length) return this.$message.warning("请完善销售经理信息");
			if(condition02.length) return this.$message.warning("请完善培训人员信息");
			if(condition03.length) return this.$message.warning("培训方式不能为空");
			if(this.salesManagerSetList.filter(item => !this.isPhoneNumber(item.telephone) && !item.isDelete).length) return;
			if(this.trainerSetList.filter(item => !this.isPhoneNumber(item.telephone) && !item.isDelete).length) return;
			savePersonList({personType: 1, personList: this.trainerSetList.filter(item => !item.isDelete)}).then(()=>{this.getTrainerList()}).catch(() => {});
			savePersonList({personType: 3, personList: this.salesManagerSetList.filter(item => !item.isDelete)}).then(()=>{this.getSalesManagerList()}).catch(() => {});
			saveUnitDictionary({dicType: 2, dicList: this.trainTypeSetOptions.filter(item => !item.isDelete)}).then(()=>{this.getTrainWayDict()}).catch(() => {});
			this.$message.success("保存成功");
			this.cancalSet();
		},
		toSettings() {
			this.getSalesManagerList();
			this.getTrainerList();
			this.getTrainWayDict();
			this.setDialogVisible = true
		},
		// 获取销售经理列表
		getSalesManagerList() {
			getUserListByType({
				personType: 3
			},{isinclueddelete: true}).then(res => {
				this.salesManagerList = res.data.data;
				this.salesManagerSetList = _.cloneDeep(this.salesManagerList);
			})
		},
		// 获取培训人员列表
		getTrainerList() {
			getUserListByType({
				personType: 1
			},{isinclueddelete: true}).then(res => {
				this.trainerList = res.data.data;
				this.trainerSetList = _.cloneDeep(this.trainerList);
			})
		},
		// 获取培训方式字典
		getTrainWayDict() {
			// 数量单位 1 培训方式 2
			getDataDictionary({
				dictype : 2,
				isinclueddelete: true
			}).then((res) => {
				this.trainTypeOptions = res.data.data.map((item) => ({
					...item,
					text: item.dicName,
					value: item.dicId
				}));
				this.trainTypeSetOptions = _.cloneDeep(this.trainTypeOptions)
			}).catch(() => {});
		},
		getTrainPageList() {
			let params = {
				pageIndex: this.pageIndex,
				pageSize: this.pagesize,
				...this.search,
				startTrainDate: this.search.trainDate?this.search.trainDate[0]:'',
				endTrainDate: this.search.trainDate?this.search.trainDate[1]:'',
				salePersonId: this.search.salesManager
			}
			params = _.omitBy(params, val => val === '');
			delete params.trainDate;
			delete params.salesManager
			getProcuctList(params).then(res => {
				this.tableData = res.data.data.items
				this.total = res.data.data.totalCount
			}).catch(() => {})
		},
		handleSizeChange(val) {
			this.pagesize = val;
			this.getTrainPageList();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getTrainPageList();
		},
		changeInput(index, type) {
			switch(type) {
				case 'salesManager':
					if(this.salesManagerSetList[index]['name'] === "" && this.salesManagerSetList[index]['telephone'] === "") {
						this.salesManagerSetList.splice(index, 1);
					}
					break;
				case 'trainer':
					if(this.trainerSetList[index]['name'] === "" && this.trainerSetList[index]['telephone'] === "") {
						this.trainerSetList.splice(index, 1);
					}
					break;
				case 'trainWay':
					if(this.trainTypeSetOptions[index]['dicName'] === "" ) {
						this.trainTypeSetOptions.splice(index, 1);
					}
					break;
				default:
					break;
			}
			
		}
	}
}
</script>

<style lang="scss" scoped>
#approvalForm, #approvalBatchForm {
	color: black;
	background: white;
	width: 820px;
	height: 920px;
	padding: 20px;
	position: absolute;
	top: -2000px;
	.row-column {
		margin-left: -1px;
		border: 1px solid black;
		border-bottom: none;
		border-top: none;
		text-align: center;
		line-height: 56px;
		box-sizing: border-box;
	}
	.pdf-row {
		width: 100%;
		border: 1px solid black;
		display: flex;
		.row-column:last-of-type {
			border-right: none;
		}
	}
	.pdf-row-1 {
		height: 56px;
		.row-1-column-1 {
			flex: 3;
			color: 18px;
			font-weight: bold;
		}
		.row-1-column-2, .row-1-column-3 {
			flex: 1;
		}
	}
	.pdf-row-2 {
		height: 48px;
		margin-top: -1px;
		.row-2-column-1 {
			flex: 1
		}
		.row-2-column-2 {
			flex: 4
		}
	}
	.pdf-row-3 {
		height: 48px;
		margin-top: -1px;
		.row-3-column-1 {
			flex: 2;
			margin-left: 0px;
			margin-right: -1px;
			border-left: none;
		}
		.row-3-column-2 {
			flex: 3;
			border-left: none;
		}
	}
	.pdf-row-4 {
		height: 320px;
		margin-top: -1px;
		display: block;
		.suggestion {
			padding: 10px;
			font-weight: bold;
		}
		.suggestion-content {
			padding-left: 34px;
		}
	}
	.pdf-row-5 {
		height: 112px;
		margin-top: -1px;
		.row-5-column-1 {
			width: 42px !important;
			padding: 0 5px;
			line-height: 36px;
		}
		.row-5-column-2 {
			flex: 1;
			display: flex;
			flex-direction: column;
			.label {
				flex: 1;
				border-bottom: 1px solid black;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.content {
				flex: 1;
				display: flex;
				justify-content: center;
				align-items: center;
				.image-content {
					width: 100px;
					height: 50px;
					background-image: url('https://ss0.baidu.com/7Po3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/eac4b74543a98226d07efeeb8a82b9014b90ebbb.jpg)');
					background-repeat: no-repeat;
					background-position: center center;
					background-size: cover;
				}
			}
		}
	}
}
.view-detail {
	top: 20px !important;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
	z-index: 2;
	.el-icon-circle-close {
		position: absolute;
		top: 5px;
		right: -45px;
		font-size: 36px;
		font-weight: bold;
		color: white;
		cursor: pointer;
	}
}
</style>
